import React from 'react';
import '../Common/Warning.scss';

const Warning: React.FC<{ onClick: () => void, onAdvancedClick: () => void }> = ({ onClick, onAdvancedClick }) => (
  <div className="web3-wc_hd-wallet_warning web3-wc_hd-wallet__common-container">
    <h4>Before proceeding make sure</h4>
    <ol>
      <li>Your Trezor is updated and connected</li>
      <li>Note - Trezor doesn’t support EIP 712</li>
      <li>You will be redirected to unlock your Trezor</li>
    </ol>
    <button type="button" className="web3-wc_hd-wallet_warning_confirm" onClick={onClick}>Continue</button>
    <a onClick={onAdvancedClick} className="web3-wc_hd-wallet-advanced">Advanced  - select derivation path</a>
  </div>
);

export default Warning;
